export type RibbonTelemetryControlCategory = "BuiltIn" | "Category" | "Signature" | "QuickPart" | "ComposePinnedAddIn" | "ReadPinnedAddIn" | "InstalledAddIn" | "OtherDynamic";

const COMPOSE_PINNED_ADDIN_START = 90000;
const READ_PINNED_ADDIN_START = 90500;
const INSTALLED_ADDIN_START = 91000;
const RUNTIME_CONTROL_END = 99999;

export function getRibbonTelemetryControlCategory(id: string | number, idNumber: number): RibbonTelemetryControlCategory {
    if (idNumber >= COMPOSE_PINNED_ADDIN_START && idNumber < READ_PINNED_ADDIN_START) {
        return "ComposePinnedAddIn";
    }
    if (idNumber >= READ_PINNED_ADDIN_START && idNumber < INSTALLED_ADDIN_START) {
        return "ReadPinnedAddIn";
    }
    if (idNumber >= INSTALLED_ADDIN_START && idNumber <= RUNTIME_CONTROL_END) {
        return "InstalledAddIn";
    }
    if (idNumber !== -1) {
        return "BuiltIn";
    }
    
    const idString = id.toString();
    if (idString.startsWith("categoryMenu_")) {
        return "Category";
    }
    if (idString.startsWith("sig_")) {
        return "Signature";
    }
    if (idString.startsWith("quickpart_")) {
        return "QuickPart";
    }
    return "OtherDynamic";
}
